import { actions } from '../../constants';

const initialState = {
  data: [],
  isLoading: false,
  errorMessage: ''
};

export default function users(state = initialState, action) {
  switch (action.type) {
    case actions.AWARDS.LOAD:
      return { ...state, isLoading: true };
    case actions.AWARDS.LOAD_SUCCESS:
      return {
        ...state,
        data: action.payload.result.data,
        isLoading: false,
        errorMessage: ''
      };
    case actions.AWARDS.LOAD_FAIL:
      return { ...state, isLoading: false, errorMessage: action.payload.error };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/awards.js